import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';

export interface LoginData{
  user:string;
  pass:string;
}

@Component({
  selector: 'app-login-dlg',
  templateUrl: './login-dlg.component.html',
  styleUrls: ['./login-dlg.component.scss']
})
export class LoginDlgComponent implements OnInit {

  userinf: LoginData = {user:'', pass:''};
  constructor(public dialogRef: MatDialogRef<LoginDlgComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LoginData) { }

  ngOnInit() {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
